<template>
  <div class="user-management">
    <template>
      <h4 style="color: aliceblue;margin-top: -30px">
        {{title}}
      </h4>
    </template>
    <el-row :gutter="40">
      <el-col :span="24" :xs="24">
        <el-form ref="queryForm" :inline="true" :model="queryParams" label-width="68px" size="small">
          <el-form-item>
            <el-button icon="el-icon-plus" type="primary" @click="handleAdd">新增
            </el-button>

          </el-form-item>
          <el-form-item>
            <el-input v-model="queryParams.plateNo" placeholder="车牌号" />
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="queryParams.Time" prefix-icon="el-icon-date" type="datetimerange"
              start-placeholder="申报开始日期" end-placeholder="申报结束日期" size="small" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select v-model="queryParams.checkStatus" placeholder="审批状态">
              <el-option label="全部" value="" />
              <el-option v-for="item in checkstatus" :key="item.code" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="handleQuery">搜索</el-button>
            <el-button
              type="primary"
              icon="el-icon-upload2"
              style="margin-left:15px"
              v-if="declareType == 1 && vehicleType == 1 &&(roleType==1 || roleType==2)"
              @click="handleImport"
              >批量导入
            </el-button>
            <!-- <el-button icon="el-icon-refresh" @click="handleReset"
              >重置</el-button
            > -->
          </el-form-item>
        </el-form>

        <el-table v-loading="loading" element-loading-text="数据载入中" element-loading-spinner="el-icon-loading"
          :data="pageList" :show-overflow-tooltip="true">

          <el-table-column align="center" label="所属企业" prop="coName" show-overflow-tooltip v-if="vehicleType != 6"/>
          <el-table-column align="center" label="访问企业" prop="accessName" show-overflow-tooltip v-if="declareType == 1"/>
          <el-table-column align="center" label="司机姓名" prop="name" width="100" />
          <el-table-column align="center" label="司机手机号" prop="mobile" width="140" />
          <el-table-column align="center" label="司机身份证" prop="idCard" show-overflow-tooltip/>
          <el-table-column align="center" label="车牌号码" prop="plateNo" width="150" />
          <el-table-column align="center" label="车牌颜色" prop="plateColor" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.plateColor == 1">黑色</span>
              <span v-if="scope.row.plateColor == 2">白色</span>
              <span v-if="scope.row.plateColor == 5">蓝色</span>
              <span v-if="scope.row.plateColor == 6">黄色</span>
              <span v-if="scope.row.plateColor == 9">绿色</span>
              <span v-if="scope.row.plateColor == 99">未知</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="有效期始" prop="validityPeriodStart" width="120" />
          <el-table-column align="center" label="有效期止" prop="validityPeriodEnd" width="120" />
          <el-table-column align="center" label="申报时间" prop="createTime" width="100" />
          <el-table-column align="center" label="审批状态" prop="checkStatus" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.checkStatus == 0"><b>未审批</b></span>
              <span v-if="scope.row.checkStatus == 1" style="color: green;"><b>审批通过</b></span>
              <span v-if="scope.row.checkStatus == 2" style="color: red;"><b>审批未通过</b></span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="事由" prop="reason" width="100"  v-if="!(declareType != 2 && vehicleType == 1)" show-overflow-tooltip/>
          <el-table-column align="center" label="备注" prop="remark" width="100"  v-if="declareType != 2 && vehicleType == 1" show-overflow-tooltip/>
          <el-table-column align="center" label="操作" width="180">
            <template slot-scope="scope">
              <el-button v-if="scope.row.checkStatus != 0" type="info" size="mini" circle plain
                @click.stop="handleDetail(scope.row,1)">再次申报</el-button>
              <el-button type="success" size="mini" circle plain @click.stop="handleDetail(scope.row,2)">详情</el-button>
              <el-button type="danger" icon="el-icon-delete" size="mini" circle plain
                @click.stop="handleDelete(scope.row)" />
            </template>
          </el-table-column>
        </el-table>

        <commonPagination :page="pagination" :pageSizes="[10, 20, 30, 40, 50, 100]" :getList="handleQuery">
        </commonPagination>
      </el-col>
    </el-row>
    <!-- 新增或修改参数配置对话框 -->
    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" width="800px">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="12" v-if="form.vehicleType != 6">
            <el-form-item label="所属企业" prop="coId">
              <el-select v-model="form.coId" filterable placeholder="请输入或选择" :disabled="disabled">
                <el-option v-for="item in company" :key="item.value" :label="item.lable" :value="parseInt(item.value)" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.declareType == 1">
            <el-form-item label="访问企业" prop="coId">
              <el-select v-model="form.accessId" filterable placeholder="请输入或选择" :disabled="disabled">
                <el-option v-for="item in company" :key="item.value" :label="item.lable" :value="parseInt(item.value)" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机姓名" prop="name">
              <el-input v-model="form.name" placeholder="请输入司机姓名" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机手机号" prop="mobile">
              <el-input v-model="form.mobile" placeholder="请输入司机手机号" type="number" oninput="if(value.length>11)value=value.slice(0,11)" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机身份证" prop="idCard">
              <el-input v-model="form.idCard" placeholder="请输入司机身份证" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车牌号码" prop="plateNo">
              <el-input v-model="form.plateNo" placeholder="请输入车牌号码" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车牌颜色" prop="plateColor">
              <el-select v-model="form.plateColor" placeholder="请选择" :disabled="disabled">
                <el-option v-for="item in platecolor" :key="item.value" :label="item.name" :value="parseInt(item.code)" />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12" v-if="form.declareType == 2">
            <el-form-item label="进出日期" prop="validityPeriodStart">
              <el-date-picker v-model="form.validityPeriodStart"  value-format="yyyy-MM-dd"
                type="date" :picker-options="pickerOptions" :disabled="disabled"></el-date-picker>
            </el-form-item>
          </el-col> -->
          <el-col :span="12" >
            <el-form-item label="有效期始" prop="validityPeriodStart">
              <el-date-picker v-model="form.validityPeriodStart"  value-format="yyyy-MM-dd"
                type="date" :picker-options="pickerOptions" :disabled="disabled"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" >
            <el-form-item label="有效期止" prop="validityPeriodEnd">
              <el-date-picker v-model="form.validityPeriodEnd"  value-format="yyyy-MM-dd"
                type="date" :picker-options="pickerOptions" :disabled="disabled"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.declareType != 2 && form.vehicleType != 4">
            <el-form-item label="每日访问时段" prop="passTime">
              <el-time-picker is-range value-format="HH:mm:ss" placeholder="选择时间" range-separator="-" size="mini"
                v-model="form.passTime1" class="u-w-80" :disabled="disabled"></el-time-picker>
              <el-time-picker is-range value-format="HH:mm:ss" placeholder="选择时间" range-separator="-" size="mini"
                v-model="form.passTime2" class="u-w-80" :disabled="disabled"></el-time-picker>
              <el-time-picker is-range value-format="HH:mm:ss" placeholder="选择时间" range-separator="-" size="mini"
                v-model="form.passTime3" class="u-w-80" :disabled="disabled"></el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.declareType == 2 && form.vehicleType != 4">
            <el-form-item label="随行人员(含驾驶员)" prop="entourage">
              <el-input v-model="form.entourage" placeholder="" type="number" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.vehicleType == 3">
            <el-form-item label="货车载重(kg)" prop="carryingCapasity">
              <el-input v-model="form.carryingCapasity" placeholder="" type="number" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.vehicleType == 2">
            <el-form-item label="客运公司" prop="carrier">
              <el-input v-model="form.carrier" placeholder="" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.vehicleType == 4">
            <el-form-item label="货物类型" prop="goodsType">
              <el-select v-model="form.goodsType" placeholder="请选择" prop="goodsType" :disabled="disabled">
                <el-option v-for="item in goodstype" :key="item.value" :label="item.name" :value="parseInt(item.code)" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.vehicleType == 4">
            <el-form-item label="货物名称" prop="goodsName">
              <el-input v-model="form.goodsName" placeholder="请输入货物名称" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.vehicleType == 4">
            <el-form-item label="押运人姓名" prop="supercargoName">
              <el-input v-model="form.supercargoName" placeholder="请输入押运人姓名" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.vehicleType == 4">
            <el-form-item label="押运人手机" prop="supercargoMobile">
              <el-input v-model="form.supercargoMobile" placeholder="请输入押运人手机号" type="number" oninput="if(value.length>11)value=value.slice(0,11)" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.vehicleType == 4">
            <el-form-item label="押运人身份证" prop="supercargoIdcard">
              <el-input v-model="form.supercargoIdcard" placeholder="请输入押运人身份证" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.vehicleType == 4 || form.vehicleType == 3">
            <el-form-item label="承运公司" prop="carrier">
              <el-input v-model="form.carrier" placeholder="请输入承运公司" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="!(form.declareType != 2 && form.vehicleType == 1)">
            <el-form-item label="事由" prop="reason">
              <el-input v-model="form.reason" placeholder="" type="textarea" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="进入区域" prop="intoArea">
              <el-select v-model="form.intoArea" placeholder="请选择" prop="intoArea" :disabled="disabled">
                <el-option v-for="item in intoAreas" :key="item.value" :label="item.name" :value="parseInt(item.code)" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.declareType != 2 && form.vehicleType == 1">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="form.remark" placeholder="" type="textarea" :disabled="disabled" />
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="!dialog.flag">
            <el-form-item label="审批意见" prop="checkOpinion">
              <el-input v-model="form.checkOpinion" placeholder="" type="textarea" :disabled="disabled" />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="dialog.flag &&(form.vehicleType == 3 || form.vehicleType == 4)">
            <el-form-item label="驾驶证" prop="drivingLicense">
              <el-upload ref="upload" list-type="picture-card" action="#" :multiple="false" :limit="1" :class="{disUoloadSty:noneBtnImg1}" :http-request="(file,fileList)=>{ upload1(file,fileList, 'drivingLicense')}"
               :on-change="(file, fileList) => {dealImgChange(file, fileList, 1)}" :on-remove="(file,fileList)=>{ removeFile(file,fileList, 'drivingLicense',1)}" :auto-upload="true"  :file-list="fileList1" :before-upload="beforeAvatarUpload">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!dialog.flag &&(form.vehicleType == 3 || form.vehicleType == 4)">
            <el-form-item label="驾驶证" prop="drivingLicense">
              <img :src="form.drivingLicense" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.drivingLicense)">
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="dialog.flag &&(form.vehicleType == 3 || form.vehicleType == 4)">
            <el-form-item label="行驶证" prop="vehicleLicense">
              <el-upload ref="upload" list-type="picture-card" action="#" :multiple="false" :limit="1" :class="{disUoloadSty:noneBtnImg2}" :http-request="(file,fileList)=>{ upload1(file,fileList, 'vehicleLicense')}"
               :on-change="(file, fileList) => {dealImgChange(file, fileList, 2)}" :on-remove="(file,fileList)=>{ removeFile(file,fileList, 'vehicleLicense',2)}" :auto-upload="true"  :file-list="fileList2" :before-upload="beforeAvatarUpload">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!dialog.flag &&(form.vehicleType == 3 || form.vehicleType == 4)">
            <el-form-item label="行驶证" prop="vehicleLicense">
              <img :src="form.vehicleLicense" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.vehicleLicense)">
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="dialog.flag && form.vehicleType == 4">
            <el-form-item label="押运证" prop="escortLicense">
              <el-upload ref="upload" list-type="picture-card" action="#" :multiple="false" :limit="1" :class="{disUoloadSty:noneBtnImg3}" :http-request="(file,fileList)=>{ upload1(file,fileList, 'escortLicense')}"
               :on-change="(file, fileList) => {dealImgChange(file, fileList, 3)}" :on-remove="(file,fileList)=>{ removeFile(file,fileList, 'escortLicense',3)}" :auto-upload="true"  :file-list="fileList3" :before-upload="beforeAvatarUpload">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!dialog.flag && form.vehicleType == 4">
            <el-form-item label="押运证" prop="escortLicense">
              <img :src="form.escortLicense" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.escortLicense)">
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="dialog.flag && form.vehicleType == 4">
            <el-form-item label="电子运单" prop="wayBill">
              <el-upload ref="upload" list-type="picture-card" action="#" :multiple="false" :limit="1" :class="{disUoloadSty:noneBtnImg4}" :http-request="(file,fileList)=>{ upload1(file,fileList, 'wayBill')}"
               :on-change="(file, fileList) => {dealImgChange(file, fileList, 4)}" :on-remove="(file,fileList)=>{ removeFile(file,fileList, 'wayBill',4)}" :auto-upload="true"  :file-list="fileList4" :before-upload="beforeAvatarUpload">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!dialog.flag && form.vehicleType == 4">
            <el-form-item label="电子运单" prop="wayBill">
              <img :src="form.wayBill" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.wayBill)">
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="dialog.flag && form.vehicleType == 6">
            <el-form-item label="行程单" prop="journeyImg">
              <el-upload ref="upload" list-type="picture-card" action="#" :multiple="false" :limit="1" :class="{disUoloadSty:noneBtnImg8}" :http-request="(file,fileList)=>{ upload1(file,fileList, 'journeyImg')}"
               :on-change="(file, fileList) => {dealImgChange(file, fileList, 8)}" :on-remove="(file,fileList)=>{ removeFile(file,fileList, 'journeyImg',8)}" :auto-upload="true"  :file-list="fileList8" :before-upload="beforeAvatarUpload">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!dialog.flag && form.vehicleType == 6">
            <el-form-item label="行程单" prop="journeyImg">
              <img :src="form.journeyImg" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.journeyImg)">
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="dialog.flag && (form.declareType == 2 || form.vehicleType == 4)">
            <el-form-item label="健康码" prop="ykCode">
              <el-upload ref="upload" list-type="picture-card" action="#" :multiple="false" :limit="1" :class="{disUoloadSty:noneBtnImg5}" :http-request="(file,fileList)=>{ upload1(file,fileList, 'ykCode')}"
               :on-change="(file, fileList) => {dealImgChange(file, fileList, 5)}" :on-remove="(file,fileList)=>{ removeFile(file,fileList, 'ykCode',5)}" :auto-upload="true"  :file-list="fileList5" :before-upload="beforeAvatarUpload">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!dialog.flag && (form.declareType == 2 || form.vehicleType == 4)">
            <el-form-item label="健康码" prop="ykCode">
              <img :src="form.ykCode" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.ykCode)">
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="dialog.flag && (form.declareType == 2 || form.vehicleType == 4)">
            <el-form-item label="行程码" prop="xcCode">
              <el-upload ref="upload" list-type="picture-card" action="#" :multiple="false" :limit="1" :class="{disUoloadSty:noneBtnImg6}" :http-request="(file,fileList)=>{ upload1(file,fileList, 'xcCode')}"
               :on-change="(file, fileList) => {dealImgChange(file, fileList, 6)}" :on-remove="(file,fileList)=>{ removeFile(file,fileList, 'xcCode',6)}" :auto-upload="true"  :file-list="fileList6" :before-upload="beforeAvatarUpload">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!dialog.flag && (form.declareType == 2 || form.vehicleType == 4)">
            <el-form-item label="行程码" prop="xcCode">
              <img :src="form.xcCode" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.xcCode)">
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="dialog.flag && (form.declareType == 2 || form.vehicleType == 4)">
            <el-form-item label="核酸报告" prop="yyCode">
              <el-upload ref="upload" list-type="picture-card" action="#" :multiple="false" :limit="1" :class="{disUoloadSty:noneBtnImg7}" :http-request="(file,fileList)=>{ upload1(file,fileList, 'yyCode')}"
               :on-change="(file, fileList) => {dealImgChange(file, fileList, 7)}" :on-remove="(file,fileList)=>{ removeFile(file,fileList, 'yyCode',7)}" :auto-upload="true"  :file-list="fileList7" :before-upload="beforeAvatarUpload">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!dialog.flag && (form.declareType == 2 || form.vehicleType == 4)">
            <el-form-item label="核酸报告" prop="yyCode">
              <img :src="form.yyCode" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.yyCode)">
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="dialog.flag && form.declareType == 1 && form.vehicleType != 4">
            <el-form-item label="港区证明文件" prop="proveFile">
              <el-upload ref="upload" list-type="picture-card" action="#" :multiple="false" :limit="1" :class="{disUoloadSty:noneBtnImg8}" :http-request="(file,fileList)=>{ upload1(file,fileList, 'proveFile')}"
               :on-change="(file, fileList) => {dealImgChange(file, fileList, 8)}" :on-remove="(file,fileList)=>{ removeFile(file,fileList, 'proveFile',8)}" :auto-upload="true"  :file-list="fileList8" :before-upload="beforeAvatarUpload">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="dialog.flag && form.declareType == 1 && form.vehicleType != 4">
            <el-form-item label="港区文件范例" prop="proveFile">
              <img src="http://huagongyq.dingpod.cn/file/gqzmwj.jpg" width="100%" alt="" height="180px" @click="handlePictureCardPreview('http://huagongyq.dingpod.cn/file/gqzmwj.jpg')">
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!dialog.flag && form.declareType == 1 && form.vehicleType != 4">
            <el-form-item label="港区证明文件" prop="proveFile">
              <img :src="form.proveFile" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.proveFile)">
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="dialog.flag">
        <el-button type="primary" @click="handleSubmit">提 交</el-button>
        <el-button @click="dialog.visible = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-image-viewer
      v-if="!!bigImgSrc"
      :on-close="closeImgViewer"
      :url-list="[bigImgSrc]"
    />

    <el-dialog :title="upload.title" :visible.sync="upload.open" width="400px" append-to-body>
      <el-upload
        ref="upload2"
        :limit="1"
        action="#"
        accept=".xlsx, .xls"
        :file-list="fileList"
        :http-request="moreImport"
        :before-upload="beforeUpload"
        :on-change="handleChange"
        :on-remove="handleRemove"
        :disabled="upload.isUploading"
        :on-progress="handleFileUploadProgress"
        :auto-upload="false"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip text-center" slot="tip">
          <!-- <div class="el-upload__tip" slot="tip">
            <el-checkbox v-model="upload.updateSupport" /> 是否更新已经存在的用户数据
          </div> -->
          <span style="color: aliceblue;">仅允许导入xls、xlsx格式文件。</span>
          <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;color: aqua;" href="https://chishui-parking.oss-cn-shenzhen.aliyuncs.com/企业轿车模板.xlsx">下载模板</el-link>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFileForm">{{uploadText}}</el-button>
        <el-button @click="upload.open = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import commonPagination from "@/components/commonPagination.vue";
  import ElImageViewer from "@/components/CustomImageViewer";
  import store from '@/vuex';
  export default {
    name: "CarSb",
    components: {
      commonPagination,ElImageViewer
    },
    props: ["declareType","vehicleType"],
    data() {
      const typeTime = {
        beginTime: this.$myPlug.timeFormat(
          new Date().getTime(),
          "yyyy-mm-dd 00:00:00"
        ),
        endTime: this.$myPlug.timeFormat(new Date().getTime(), "yyyy-mm-dd 23:59:59"),
      };
      return {
        pickerOptions: {
          disabledDate(time) {
          return time.getTime() < Date.now()- 8.64e7;
        }},
        title:JSON.stringify(store.state.documentTitle_menuName).split('"')[3],
        checkstatus: JSON.parse(sessionStorage.getItem('dictionary')).CHECKSTATUS,
        platecolor:JSON.parse(sessionStorage.getItem('dictionary')).PLATECOLOR,
        goodstype:JSON.parse(sessionStorage.getItem('dictionary')).GOODSTYPE,
        intoAreas: [
          {value:'1', name: '滨海大道西侧', code: '1'},
          {value:'2', name: '滨海大道东侧', code: '2'},
          {value:'3', name: '棕榈路北侧', code: '3'},
          {value:'4', name: '海河大道北侧', code: '4'},
          {value:'5', name: '翁金线西侧', code: '5'},
          {value:'6', name: '翁金线东侧', code: '6'},
        ],
        company:JSON.parse(localStorage.getItem('company')),
        roleType: JSON.parse(localStorage.getItem('userInfo')).roleType,
        disabled:false,
        fileList1: [],
        fileList2: [],
        fileList3: [],
        fileList4: [],
        fileList5: [],
        fileList6: [],
        fileList7: [],
        fileList8: [],
        noneBtnImg1:false,
        noneBtnImg2:false,
        noneBtnImg3:false,
        noneBtnImg4:false,
        noneBtnImg5:false,
        noneBtnImg6:false,
        noneBtnImg7:false,
        noneBtnImg8:false,
        bigImgSrc: "",
        limitCountImg:1,   //上传图片的最大数量
        loading: true,
        // 选中数组
        ids: [],
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        queryParams: {
          declareType:this.declareType,
          vehicleType: this.vehicleType,
          Time: Object.values(typeTime),
        },
        pagination: {
          pageIndex: 1,
          pageRow: 10,
          total: 0
        },
        pageList: [],
        dialog: {
          title: undefined,
          visible: false,
          flag: true
        },
        apiUrl: {
          delApi: 'GET_hyCarDeclareDelete',
          addApi: 'POST_hyCarDeclareAdd',
          detailApi: 'GET_hyCarDeclareFind',
          indexApi: 'POST_hyCarDeclareIndex'
        },
        upload: {
          open: false,
          title: "",
          isUploading: false,
          updateSupport: 0,
        },
        uploadText:"",
        fileList: [],
        // 表单参数
        form: {
          carrier: "",
          carryingCapasity: 0,
          coId: "",
          declareType: 1,
          drivingLicense: "",
          entourage: 1,
          escortLicense: "",
          goodsName: "",
          goodsType: "",
          idCard: "",
          mobile: "",
          name: "",
          passTime: "00:00:00-23:59:59",
          passTime1: "00:00:00-23:59:59",
          plateColor: "",
          plateNo: "",
          reason: "",
          remark: "",
          supercargoIdcard: "",
          supercargoMobile: "",
          supercargoName: "",
          validityPeriodEnd: "",
          validityPeriodStart: "",
          vehicleLicense: "",
          vehicleType: 1,
          wayBill: "",
          ykCode: "",
          xcCode: "",
          yyCode: "",
          proveFile: "",
          journeyImg:"",
          accessId:""
        },
        // 表单校验
        rules: {
          coId: [{
            required: true,
            message: "企业不能为空",
            trigger: "blur"
          }],
          name: [{
            required: true,
            pattern: /^[\u4e00-\u9fa5a-zA-Z]+$/,
            message: "姓名只能是中文或英文(请勿输入空格)",
            trigger: "blur"
          }],
          mobile: [{
            required: true,
            pattern: /\d{11}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }],
          idCard: [{
            required: true,
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "请输入正确的身份证号",
            trigger: "blur"
          }],
          plateNo: [{
            required: true,
            // pattern: /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([a-zA-Z]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}||[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z0-9]{5}[A-Z0-9挂学警港澳领]{1})$/,
            pattern: /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([a-zA-Z]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z0-9]{5}[A-Z0-9挂学警港澳领]{1}|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z][A-Z][0-9]{5}[A-Z])$/,
            message: "请输入正确的车牌号",
            trigger: "blur"
          }],
          plateColor: [{
            required: true,
            message: "车牌颜色不能为空",
            trigger: "blur"
          }],
          validityPeriodStart: [{
            required: true,
            message: "不能为空",
            trigger: "blur"
          }],
          validityPeriodEnd: [{
            required: true,
            message: "不能为空",
            trigger: "blur"
          }],
          goodsType: [{
            required: true,
            message: "不能为空",
            trigger: "blur"
          }],
          goodsName: [{
            required: true,
            message: "不能为空",
            trigger: "blur"
          }],
          supercargoName: [{
            required: true,
            message: "不能为空",
            trigger: "blur"
          }],
          supercargoMobile: [{
            required: true,
            pattern: /\d{11}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }],
          supercargoIdcard: [{
            required: true,
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "请输入正确的身份证号",
            trigger: "blur"
          }],
          carrier: [{
            required: true,
            message: "不能为空",
            trigger: "blur"
          }],
          reason: [{
            required: true,
            message: "不能为空",
            trigger: "blur"
          }],
          drivingLicense: [{
            required: true,
            message: "驾驶证图片不能为空",
            trigger: "blur"
          }],
          vehicleLicense: [{
            required: true,
            message: "行驶证图片不能为空",
            trigger: "blur"
          }],
          escortLicense: [{
            required: true,
            message: "押运证图片不能为空",
            trigger: "blur"
          }],
          wayBill: [{
            //required: true,
            message: "电子运单图片不能为空",
            trigger: "blur"
          }],
          journeyImg: [{
            required: true,
            message: "行程信息不能为空",
            trigger: "blur"
          }],
          // ykCode: [{
          //   required: true,
          //   message: "不能为空",
          //   trigger: "blur"
          // }],
          // xcCode: [{
          //   required: true,
          //   message: "不能为空",
          //   trigger: "blur"
          // }],
          // yyCode: [{
          //   required: true,
          //   message: "不能为空",
          //   trigger: "blur"
          // }]
        }
      };
    },
    methods: {
      async loadData() {
        this.handleQuery();
      },
      handleQuery(obj = {}) {
        if ("pageNo" in obj) {
          this.queryParams.pageIndex = this.pagination.pageIndex = obj.pageNo;
        } else {
          this.queryParams.pageIndex = 1;
        }
        if ("pageSize" in obj) {
          this.queryParams.pageRow = this.pagination.pageRow = obj.pageSize;
        } else {
          this.queryParams.pageRow = this.pagination.pageRow;
        }
        this.queryParams.beginTime = "";
        this.queryParams.endTime = "";
        if(this.queryParams.Time != null){
          this.queryParams.beginTime = this.queryParams.Time[0];
          this.queryParams.endTime = this.queryParams.Time[1];
          this.$http[this.apiUrl.indexApi](this.queryParams).then(response => {
            const {
              data,
              total
            } = response;
            this.pageList = data;
            this.pagination.total = total;
            this.loading = false;
          });
        }else{
          this.$message.error("申报时间查询不能为空!");
        }

      },
      handleReset() {
        this.pagination = {
          pageIndex: 1,
          pageRow: 10,
          total: 0
        };
        this.queryParams = {

        };
        this.handleQuery();
      },

      async handleAdd() {
        this.resetForm(this.declareType,this.vehicleType);
        this.dialog = {
          title: "新增申报",
          visible: true,
          flag: true
        };
      },
      async handleDetail(row,type) {
        this.resetForm(this.declareType,this.vehicleType);
        for (var i = 1; i <= 8; i++) {
          this["noneBtnImg" + i] = true;
        }
        if (type == 1) {
          this.dialog = {
            title: "再次申报",
            visible: true,
            flag: true
          };
        } else {
          this.dialog = {
            title: "申报详情",
            visible: true,
            flag: false
          };
          this.disabled = true;
        }
        const id = row.id || this.ids;
        this.$http[this.apiUrl.detailApi]({
          paramsID: id
        }).then(response => {
          if (response.code == '00000') {
              this.form = response.data;
              this.form.plateColor = parseInt(response.data.plateColor);
              if (type == 1) {
                this.fileList1.push({'url': response.data.drivingLicense})
                this.fileList2.push({'url': response.data.vehicleLicense})
                this.fileList3.push({'url': response.data.escortLicense})
                this.fileList4.push({'url': response.data.wayBill})
                this.fileList5.push({'url': response.data.ykCode})
                this.fileList6.push({'url': response.data.xcCode})
                this.fileList7.push({'url': response.data.yyCode})
                this.fileList8.push({'url': response.data.proveFile})
              }
              if(this.declareType != 2){
                var n = response.data.passTime.split(',')
                for (var i = 1; i <= n.length; i++) {
                  this.form["passTime" + i] = n[i - 1];
                }
              }
            }else {
            if (response.msg == null)
              this.$message.error("获取数据失败！");
            else {
              this.$message.error(response.msg);
            }
          }
        });
      },

      handleSubmit: function() {
        this.$refs["form"].validate(valid => {
          if (valid) {
              if(this.declareType != 2){
                var time0 = this.form.passTime;
                var time1 = this.form.passTime1;
                var time2 = this.form.passTime2;
                var time3 = this.form.passTime3;
                if (typeof(time1) != 'string' && time1 != null && time1 != '00:00:00-23:59:59') {
                  time0 = time1[0] + '-' + time1[1];
                }else if(time1 != null){
                  time0 = time1;
                }
                if (typeof(time2) != 'string' &&time2 != null) {
                  time0 = time0 + ','+ time2[0] + '-' + time2[1];
                }else if(time2 != null){
                  time0 = time0 + ','+ time2
                }
                if (typeof(time3) != 'string' &&time3 != null) {
                  time0 = time0 + ','+ time3[0] + '-' + time3[1];
                }else if(time3 != null){
                  time0 = time0 + ','+ time3
                }
                if (time0.substr(time0.length - 1, 1) == ',') {
                  time0 = time0.slice(0, time0.length - 1);
                }
                this.form.passTime = time0;
              }
              let day3
              let message = "";
              if(this.declareType == 1){
                day3 = 1096;
                message = "三年";
              }else if(this.declareType == 2){
                day3 = 6;
                message = "7天";
                //this.form.validityPeriodEnd = this.form.validityPeriodStart;
              }else{
                day3 = 6;
                message = "7天";
              }
              let day1 = new Date(this.form.validityPeriodStart);
              let day2 = new Date(this.form.validityPeriodEnd);
              if(day1 <= day2){
                  let days = parseInt(Math.abs(day2 - day1) / 1000 / 60 / 60 / 24);
                  if(days<=day3){
                    this.$axios({
                      method: 'post',
                      url: '/dqi-hymanage/hyCarDeclare/add',
                      timeout: 30000,
                      data: this.form
                    }).then(res => {
                      if (res.code == '00000') {
                        this.$message.success("新增成功");
                        this.dialog.visible = false;
                        this.handleQuery();
                      } else {
                        this.$message.error(res.msg);
                      }
                    })
                  }else{
                    this.$message.error("有效期始到有效期止最长为"+message)
                  }
              }else{
                this.$message.error("有效期止不能早于有效期始!")
              }
          }
        });
      },

      handleDelete(row) {
        const id = row.id;
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http[this.apiUrl.delApi]({
            paramsID: id
          }).then(response => {
            if(response.code == '00000'){
              this.$message.success("删除成功");
              this.handleQuery();
            }else{
              this.$message.error(response.msg);
            }
          });
        }).catch(() => {});
      },

      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 6
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 6MB!')
        }
        return isLt2M
      },

      upload1(file, fileList,type) {
        let formData = new FormData();
        formData.append('multipartFile', file.file);
        this.$axios({
          method: 'post',
          url:'/dqi-hymanage/upload/upload/'+type,
          //headers:this.headers,
          timeout: 30000,
          data: formData
        }).then(res => {
          if(res.code=='00000'){
            this.form[type] = res.data;
           }else{
             this.$message.error(res.msg);
           }
        })
      },

      dealImgChange(file, fileList,type){
        this["noneBtnImg"+type] = fileList.length >= this.limitCountImg;
      },

      removeFile(file, fileList,type,index){
        this["noneBtnImg"+index] = fileList.length >= this.limitCountImg;
        this.form[type] = "";
      },

      handlePictureCardPreview(file) {
        this.bigImgSrc = file;
      },

      closeImgViewer(){
        this.bigImgSrc = false;
      },

      /** 导入按钮操作 */
      handleImport() {
        this.upload.title = "批量导入";
        this.upload.open = true;
        this.upload.isUploading = false;
        this.uploadText = "提 交"
      },

      // 文件上传中处理
      handleFileUploadProgress(event, file, fileList) {
        this.upload.isUploading = true;
        this.uploadText = "批量导入中..."
      },

      // 文件上传前的校验 —— 常见的校验有：校验文件类型，文件大小
      beforeUpload(file,fileList) {
          // 允许上传的文件格式列表
          let acceptList = ["xlsx", "xls"]
          // 根据文件名获取文件的后缀名
          let fileType = file.name.split('.').pop().toLowerCase()
          // 判断文件格式是否符合要求
          if (acceptList.indexOf(fileType) === -1) {
              this.$message.error('只能上传 xlsx/xls 格式的文件 !');
              return false
          }
          // 判断文件大小是否符合要求
          // if (file.size / 1024 / 1024 > 1) {
          //     this.$message.error('上传文件大小不能超过 1M !');
          //     return false
          // }
      },
      handleRemove(file, fileList) {
        this.fileList = [];
      },
      handleChange(file, fileList) {
        this.fileList = fileList.slice(-1);
      },
      moreImport(item) {
        let formData = new FormData();
        formData.append('file', item.file);
        this.$axios({
          method: 'post',
          url: '/dqi-hymanage/hyCarDeclare/uploadCardData',
          timeout: 50000,
          data: formData
        }).then(res => {
          if(res.code=='00000'){
            this.upload.open = false;
            this.upload.isUploading = false;
            this.$refs.upload2.clearFiles();
            this.fileList = [];
            this.$message.success({message:res.data,duration: 5000});
            this.handleQuery();
           }else{
             this.$message.error({message:res.msg,duration: 5000});
             this.upload.isUploading = false;
             this.$refs.upload2.clearFiles();
             this.fileList = [];
             this.uploadText = "提 交";
           }
        })
      },
      // 提交上传文件
      submitFileForm() {
        if(this.fileList.length == 1){
          this.$refs.upload2.submit();
         }else{
          this.$message.error("请先上传需要导入数据的xlsx/xls格式的文件!")
         }
      },
      // 表单重置
      resetForm(declareType,vehicleType) {
        this.form = {
          carrier: "",
          carryingCapasity: 0,
          coId: "",
          declareType: declareType,
          drivingLicense: "",
          entourage: 1,
          escortLicense: "",
          goodsName: "",
          goodsType: "",
          idCard: "",
          mobile: "",
          name: "",
          passTime: "00:00:00-23:59:59",
          passTime1: "00:00:00-23:59:59",
          plateColor: "",
          plateNo: "",
          reason: "",
          remark: "",
          supercargoIdcard: "",
          supercargoMobile: "",
          supercargoName: "",
          validityPeriodEnd: "",
          validityPeriodStart: "",
          vehicleLicense: "",
          vehicleType: vehicleType,
          wayBill: "",
          ykCode: "",
          xcCode: "",
          yyCode: "",
          proveFile: "",
          journeyImg:"",
          accessId:""
        };
        this.disabled = false;
        for (var i = 1; i <= 8; i++) {
          this["fileList"+i] = [];
          this["noneBtnImg"+i] = false;
        }
        if (this.$refs["form"]) {
          this.$nextTick(() => {
          this.$refs["form"].resetFields();
          })
        }
      }
    },
    created() {
      this.loadData();
    },
    watch: {

    }
  };
</script>

<style >
.disUoloadSty .el-upload--picture-card{
  display:none;   /* 上传按钮隐藏 */
}

.el-textarea.is-disabled .el-textarea__inner {
    background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: black;
    cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/sbgl/clsb.vue